// removed by extract-text-webpack-plugin
module.exports = {"header":"c-MembershipAccount__header","tabs":"c-MembershipAccount__tabs","tab":"c-MembershipAccount__tab","selectedTab":"c-MembershipAccount__selectedTab"};